import React, { useState } from "react";
import {
  assignReferralCodes,
  resetReferralCode
} from "./adminManualTasksService";

const AdminManualTasksPage = () => {

  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState("");

  /**
   * Assign referral codes to all existing users
   */
  const handleAssignReferralCodes = async () => {
    if (!window.confirm("Assign referral codes to all users without codes?")) return;

    setLoading(true);
    setMessage("");

    const response = await assignReferralCodes();

    setLoading(false);
    setMessage(response.message || "Task completed");
  };

  /**
   * Reset referral code for a specific user
   */
  const handleResetReferralCode = async () => {
    if (!userId) {
      alert("Please enter a user ID");
      return;
    }

    setLoading(true);
    setMessage("");

    const response = await resetReferralCode(userId);

    setLoading(false);
    setMessage(response.message || "Task completed");
  };

  return (
    <div className="admin-container">

      <h2>Manual Admin Tasks</h2>

      {loading && <p>Processing...</p>}

      {message && <p className="admin-message">{message}</p>}

      <div className="admin-task">
        <button onClick={handleAssignReferralCodes}>
          Assign Referral Codes to All Users
        </button>
      </div>

      <div className="admin-task">
        <input
          type="text"
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <button onClick={handleResetReferralCode}>
          Reset Referral Code for User
        </button>
      </div>

      {/* Future tasks can be added here */}

    </div>
  );
};

export default AdminManualTasksPage;
